import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetAgentSessionAttachmentsQuery,
  GetAgentSessionAttachmentsQueryVariables,
} from "./GetAgentSessionAttachments.generated";

export const GET_AGENT_SESSION_ATTACHMENTS: TypedDocumentNode<
  GetAgentSessionAttachmentsQuery,
  GetAgentSessionAttachmentsQueryVariables
> = gql`
  query getAgentSessionAttachments($agentSessionUuid: String!) {
    agentSessionAttachments(agentSessionUuid: $agentSessionUuid) {
      uuid
      fileName
      contentType
      storageObjectName
      fileLink
      managedFileId
      sentInEventId
    }
  }
`;
